import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { styled, FormControlLabel as MUIFormControlLabel, Switch as MUISwitch, } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
const StyledFormControlLabel = styled(MUIFormControlLabel)(({ theme }) => ({
    margin: "0",
    "& .MuiFormControlLabel-label": Object.assign(Object.assign({ marginLeft: convertPxToRem(10) }, theme.typography.largeText), { "&.Mui-disabled": {
            color: theme.palette.disabledText.main,
        } }),
}));
const StyledSwitch = styled(MUISwitch)(({ theme }) => ({
    width: convertPxToRem(40),
    height: convertPxToRem(20),
    padding: 0,
    "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: convertPxToRem(4),
        "&.Mui-checked": {
            transform: `translateX(${convertPxToRem(20)})`,
            "& .MuiSwitch-thumb": {
                color: theme.palette.primaryBlack.main,
            },
            "& + .MuiSwitch-track": {
                backgroundColor: theme.palette.sativaGreen.main,
                border: `${convertPxToRem(1.5)} solid ${theme.palette.sativaGreen.main}`,
                opacity: 1,
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                transform: `translateX(${convertPxToRem(-5)})`,
                width: convertPxToRem(17),
                borderRadius: convertPxToRem(11),
                color: theme.palette.primaryBlack.main,
            },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
            width: convertPxToRem(17),
            borderRadius: convertPxToRem(11),
            color: theme.palette.treezGrey[8],
        },
        "&.Mui-disabled": {
            "& .MuiSwitch-thumb": {
                color: theme.palette.treezGrey[5],
            },
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.treezGrey[3],
                border: `${convertPxToRem(1.5)} solid ${theme.palette.treezGrey[4]}`,
            },
        },
    },
    // Thumb: the circle
    "& .MuiSwitch-thumb": {
        borderRadius: convertPxToRem(11),
        boxShadow: "none",
        color: theme.palette.treezGrey[7],
        height: convertPxToRem(12),
        width: convertPxToRem(12),
    },
    // Track: horizontal line the circle moves across
    "& .MuiSwitch-track": {
        backgroundColor: theme.palette.primaryWhite.main,
        borderRadius: convertPxToRem(9),
        height: convertPxToRem(20 - 2),
        border: `${convertPxToRem(1.5)} solid ${theme.palette.treezGrey[5]}`,
        opacity: 1,
        transition: theme.transitions.create(["background-color"], {
            duration: 100,
        }),
    },
    "&:hover": {
        "& .MuiSwitch-switchBase:not(.Mui-disabled)": {
            "&.Mui-checked": {
                "& + .MuiSwitch-track": {
                    backgroundColor: theme.palette.treezGreen[6],
                    borderColor: theme.palette.treezGreen[6],
                },
            },
        },
        "& .MuiSwitch-thumb": {
            color: theme.palette.treezGrey[8],
        },
        "& .MuiSwitch-track": {
            borderColor: theme.palette.treezGrey[8],
        },
    },
}));
export const Switch = ({ defaultChecked, disabled = false, label, onChange, testId, value, checked, }) => {
    const [checkedState, setCheckedState] = useState(defaultChecked || checked || false);
    const handleChange = (event) => {
        const target = event.target;
        setCheckedState(target.checked);
        if (onChange) {
            onChange(target.checked);
        }
    };
    useEffect(() => {
        if (typeof checked === "boolean") {
            setCheckedState(checked);
        }
    }, [checked]);
    return (_jsx(StyledFormControlLabel, { control: _jsx(StyledSwitch, { id: label, "aria-checked": checkedState }), "data-testid": testId, label: label, onChange: handleChange, value: value, disabled: disabled, checked: checkedState }));
};
